module.exports = __webpack_public_path__ + "static/media/SIG2.1024d6dc.png";